
  // Function to extract query parameters from the URL
  function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  // Get the quantity parameter from the URL
  var quantityParam = getParameterByName('quantity');

  // Select the input element with data-xpv-key="aantalNamen"
  var inputElement = document.querySelector('[data-xpv-key="att-quantity"] input');

  // Add an event listener to the input element
  inputElement.addEventListener('change', function() {
    var inputValue = parseInt(this.value); // Parse the input value as an integer
    if (!isNaN(inputValue) && quantityParam !== null) {
      // Check if the input value exceeds the quantity parameter
      if (inputValue > parseInt(quantityParam)) {
        alert('Input value cannot be higher than the quantity parameter from the URL.');
        this.value = quantityParam; // Set the input value to the quantity parameter
      }
    }
  });
